/**
 * HTTP headers that the Arcade gateway sets on outbound MCP worker requests.
 * Allowlisting any of these will overwrite the gateway's own value and may
 * break the worker connection.
 */
const INTERNAL_GATEWAY_HEADERS = new Set(
  [
    "Authorization",
    "Content-Type",
    "Content-Length",
    "Host",
    "Connection",
    "Transfer-Encoding",
    "Accept",
    "User-Agent",
    "Mcp-Session-Id",
    "Mcp-Protocol-Version",
  ].map((h) => h.toLowerCase())
);

export const isInternalHeader = (name: string): boolean =>
  INTERNAL_GATEWAY_HEADERS.has(name.toLowerCase());
